export enum STOCK_STATUS {
    IN_STOCK = 0,
    OUT_OF_STOCK = 1,
}
export enum IDENTIFIER_TYPE {
    NONE = 'NONE',
    MAC = 'MAC',
    BARCODE = 'BARCODE',
}
export const STOCK_FORMAT: Record<string | number, string> = {
    0: 'Normal Display',
    1: 'Out of Stock',
};
export interface ProductStockInfoRequest {
    store_id: number;
    scope: string;
    keyword: string;
}
export interface SetProductStockInfoRequest {
    keyword: string;
    store_id: number;
    inventory_state: number;
    do_push_devices: boolean;
}
export interface ProductStockInfoRequest {
    store_id: number;
    keyword: string;
}
export interface ProductInfoResponse {
    results: {
        http_status: number;
        keyword: string;
        message: string;
        payload: ProductStockData;
    }[];
}
export interface ProductStockData {
    product_name: string;
    product_number: string;
    product_barcode: string;
    associated_devices: string[];
    total_associated_devices: number;
    product_inventory_state: number | null;
    status: string;
    keyword_type: string;
}
export interface ProductStockResponse {
    error_code: string | undefined;
    allSuccess: boolean;
    push_information: {
        success_macs: Array<{
            device_id: number;
            mac: string;
            page_idx: number;
            battery_lv: number;
        }>;
        failed_macs: { mac: string; reason: string }[];
    };
    product_information: {
        [barcode: string]: {
            id: number;
            store_id: number;
            barcode: string;
            number: string;
            alternative_barcode1: string | null;
            alternative_barcode2: string | null;
            name: string;
            area: string;
            unit: string;
            price: number | null;
            promo_price: number | null;
            custom_fields: string;
            default_layout: number | null;
            img_path: string | null;
            product_status: number;
            inventory_state: number;
            created_by: number;
            updated_by: number;
            created_at: string;
            updated_at: string;
            deleted_at: string | null;
        };
    };
    problem: string;
    trace_steps: {
        first: {
            status: boolean;
            unique_id: string;
            last_step: string;
            reason: string;
            error_code: string;
            subworkingfolder: string;
            failed_macs: { reason: string }[];
            successful_macs: {
                device_id: number;
                mac: string;
                page_idx: number;
                gw_mac: string;
                job_uuid: string;
                pdu_size: number;
                store_id: number;
                product_snapshot: string;
                battery_lv: number;
                layout_id: string;
            }[];
        };
        two: {
            status: boolean;
            zip_name: string;
            full_path: string;
            error_code: string;
        };
        three: {
            status: boolean;
            reason: string;
            error_code: string;
        };
    };
}

export type InfoItem = {
    key: keyof ProductStockData;
    label: string;
    isArray?: boolean;
};
export const stockLabelInfo: InfoItem[] = [
    { label: 'Name', key: 'product_name' },
    { label: 'ESL MAC', key: 'associated_devices', isArray: true },
    { label: 'Barcode', key: 'product_barcode' },
    { label: 'Stock status', key: 'product_inventory_state' },
];
export const formatDisplayByKey = (key: string, value: string) => {
    if (key === 'product_inventory_state') {
        return STOCK_FORMAT[value];
    }
    return value || 'N/A';
};
